import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import './login.css';
const Login = () => {
  const navigate = useNavigate(); // useNavigate 훅을 사용하여 navigate 객체 가져오기

  const [km_bm_id, setUsername] = useState('');
  const [km_bm_pwd, setPassword] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios.post('/backend/login_new.php', {
      km_bm_id,
      km_bm_pwd,
    })
    .then((response) => {
      console.log(response);
      console.log(response.data);
      let result = response.data;

      console.log(result.status);
      if (result.status === 'success') {
        const token = result.token;
        const secretKey = result.secretKey;
        // 로그인 성공 시 메인 페이지로 리디렉션
        localStorage.setItem('token', token); // 토큰을 로컬 스토리지에 저장
        localStorage.setItem('secretKey', secretKey);
        navigate('/'); // 메인 페이지로 이동
      } else {
        alert(result.message);
      }
    })
    .catch((e) => {
      console.log(e);
    });

    return false;
  };
  return (
   <div className="container">
      <div className="page">
         <div className="AppL App-headerL gnb_bsL">
          <div className="body">
            <form className="login_form" method="post" onSubmit={handleSubmit}>
               <input
                className="login_box"
                type="text"
                id="km_bm_id"
                name="km_bm_id" // name 속성 추가
                value={km_bm_id}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="학번/사번을 입력해주세요"
                />
               <input
                className="login_box"
                type="password"
                value={km_bm_pwd}
                name="km_bm_pwd" // name 속성 추가
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호를 입력해주세요"
              />
            <button type="submit" className="login_submit">로그인</button>
            </form>
          </div>
	      </div>
	    </div>
	  </div>
	);
};
export default Login;